import Swal from 'sweetalert2'
window.Swal = Swal;

import flatpickr from "flatpickr";
window.flatpickr = flatpickr;

import moment from 'moment';
window.moment = moment;

window.Pikaday = require("pikaday");
window.Pickr = require('@simonwep/pickr');
window.timepicker = require('jquery-timepicker/jquery.timepicker');

import SignaturePad from "signature_pad";
window.SignaturePad = SignaturePad;

import select2 from "select2";
window.select2 = select2;

import toastr from "toastr";
window.toastr = toastr;

import "jquery-ui/ui/widgets/datepicker";

require('./bootstrap');

require('bootstrap');
require('datatables.net-bs4');
require('datatables.net-buttons-bs4');
require('datatables.net-fixedcolumns-bs4');
//require('datatables.net-fixedheader-bs4');

window.dataTableDefaultConfig = {
    "dom": '<"row top"<"col-md-6"i><"col-md-6 text-left"f>>r<"table-responsive"t><"row bottom mt-4"<"col-md-6"l><"col-md-6"p>><"clear">',
    "autoWidth": false,
    "info": true,
    "stateSave": true,
    "pageLength": 10,
    "lengthMenu": [[5, 10, 25, 50/*, -1*/], [5, 10, 25, 50/*, "All"*/]],
    "language": {
        "url": "https://cdn.datatables.net/plug-ins/1.10.12/i18n/Italian.json"
    }
};
window.dataTableHomeConfig = {
    "dom": 'r<"table-responsive"t><"row bottom m-3"<"col-md-6"f><"col-md-6"p>><"clear">',
    "autoWidth": false,
    "info": false,
    "pageLength": 10,
    "lengthMenu": [[5, 10, 25, 50/*, -1*/], [5, 10, 25, 50/*, "All"*/]],
    "language": {
        "url": "https://cdn.datatables.net/plug-ins/1.10.12/i18n/Italian.json"
    },
    "processing": true,
    "serverSide": true,
    "searching": true,
    "fixedColumns": true,
};

window.addEventListener('livewire-alert', event => {
    toastr[event.detail.type](event.detail.message,
        event.detail.title ?? ''), toastr.options = {
        "closeButton": true,
        "progressBar": true,
    }
});

$(function () {

    /*$('.nav-tabs a').on('shown.bs.tab', function(event){
        loadSignature();
    });*/
    loadSignature();

    // prevent submit form by enter button
    jQuery('input:not(.enable-enter)').on('keydown', function(event){
        if (event.key === "Enter" || event.keyCode === 13) {
            event.preventDefault();
            return false;
        }
    });

    // switcher
    $('body').on('change', '.switch-processed input', function() {
        axios.post('/admin/warehouse/proposal/processed/'+$( this ).data('id')+'/'+$( this ).is(':checked'))
            .then( (response) => { $('#proposal-table').DataTable().ajax.reload() });
    });

    // reset button on datatable filter
    $('.datatable-search-form').on('click', '.btn-reset', function() {
        $(this).parent().find('input').val('').trigger('keyup').trigger('change');
    });
    $('.datatable-search-form').on('click', '.btn-reset-all', function() {
        let form = $(this).closest('.datatable-search-form');
        form.find('input').val('').trigger('keyup').trigger('change');
        form.find('select').val('').change();
    });

    // confirm before delete
    $('body').on('click', '.override.with-confirm', function(event) {
        event.preventDefault();
        let href = $(this).attr('href');
        Swal.fire({
            title: 'Sei sicuro di voler cambiare lo stato?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Conferma',
            cancelButtonText: 'Annulla',
            reverseButtons: true,
        }).then((result) => {
            if (result.value) {
                window.location = href;
            }
        });
    });

    // confirm before delete
    $('body').on('click', '.remove.with-confirm', function(event) {
        event.preventDefault();
        let href = $(this).attr('href');
        Swal.fire({
            title: 'Sei sicuro di voler rimuovere?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Conferma',
            cancelButtonText: 'Annulla',
            reverseButtons: true,
        }).then((result) => {
            if (result.value) {
                window.location = href;
            }
        });
    });

    // confirm before cancel
    $('body').on('click', '.cancel.with-confirm', function(event) {
        event.preventDefault();
        let href = $(this).attr('href');
        Swal.fire({
            title: 'Sei sicuro di voler annullare?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Conferma',
            cancelButtonText: 'Annulla',
            reverseButtons: true,
        }).then((result) => {
            if (result.value) {
                window.location = href;
            }
        });
    });

});

function resizeCanvas() {
    $('.signature-wrapper').each(function( index ) {
        let signature_wrapper = $( this );
        let canvas = signature_wrapper.find('.signature')[0];
        let width_size = 300;
        let height_size = 180;
        let ratio = Math.max(window.devicePixelRatio || 1, 1);

        // When zoomed out to less than 100%, for some very strange reason,
        // some browsers report devicePixelRatio as less than 1
        // and only part of the canvas is cleared then.
        /*let ratio = Math.max(window.devicePixelRatio || 1, 1);
        canvas.width = canvas.offsetWidth * ratio;
        canvas.height = canvas.offsetHeight * ratio;
        canvas.getContext("2d").scale(ratio, ratio);*/

        if(signature_wrapper.width()<=width_size) {
            canvas.width = signature_wrapper.width();
            canvas.height = (canvas.width * height_size / width_size);

            let new_ratio = (ratio * (canvas.width/width_size));

            //canvas.getContext("2d").scale(new_ratio, new_ratio);
        } else {
            canvas.width = width_size;
            canvas.height = height_size;
            //canvas.getContext("2d").scale(ratio, ratio);
        }
    });
}

function loadSignature() {
    // signature ----------------------------------------------------
    //https://github.com/szimek/signature_pad
    //https://jsfiddle.net/jq9cyzuc/
    if( $('.signature-wrapper').length ) {

        $('.signature-wrapper').each(function( index ) {
            let signature_wrapper = $( this );
            let canvas = signature_wrapper.find('.signature')[0];

            // load plugin
            let signaturePad = new SignaturePad(canvas, {
                backgroundColor: 'rgb(255, 255, 255)', // necessary for saving image as JPEG; can be removed is only saving as PNG or SVG
                penColor: 'rgb(0, 0, 0)',
                onEnd: function() {
                    // set new value
                    signature_wrapper.find('.signature64').val( signaturePad.toDataURL() );
                    // dispatch event for Livewire
                    signature_wrapper.find('.signature64')[0].dispatchEvent(new Event('input'));
                }
            });
            // load signature on form edit
            signaturePad.fromDataURL( signature_wrapper.find('.signature64').val() );

            // reset button
            signature_wrapper.find('.btn-clear')[0].addEventListener('click', function () {
                signaturePad.clear();
                signature_wrapper.find('.signature64').val('');
                // dispatch event for Livewire
                signature_wrapper.find('.signature64')[0].dispatchEvent(new Event('input'));
            });
        });
        // resize canvas for mobile
        /*window.onresize = resizeCanvas;
        resizeCanvas();*/

        /*let canvas = document.getElementById('signature');

        window.onresize = resizeCanvas;
        resizeCanvas();

        let signaturePad = new SignaturePad(canvas, {
            backgroundColor: 'rgb(255, 255, 255)', // necessary for saving image as JPEG; can be removed is only saving as PNG or SVG
            penColor: 'rgb(0, 0, 0)',
            onEnd: function() {
                // set new value
                $('#signature64').val( signaturePad.toDataURL() );
                // dispatch event for Livewire
                document.getElementById('signature64').dispatchEvent(new Event('input'));
            }
        });
        signaturePad.fromDataURL($('#signature64').val());

        document.getElementById('clear').addEventListener('click', function () {
            signaturePad.clear();
            $('#signature64').val('');
            // dispatch event for Livewire
            document.getElementById('signature64').dispatchEvent(new Event('input'));
        });*/
    }
}
